export default __webpack_public_path__ + "static/media/FA-StackedLogo-Dark-RGB.ffa419ff.png";